import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useActivitiesResource from "../resources/useActivitiesResource";
import type { Activity as ActivityType } from "../resources/types/activitiesTypes";

const Activity = () => {
  const navigate = useNavigate();
  const { getActivities } = useActivitiesResource();
  const [activities, setActivities] = useState<ActivityType[]>([]);
  const rawHandle = localStorage.getItem("handle");
  const handle = rawHandle ? JSON.parse(rawHandle) : null;

  const fetchActivity = async () => {
    try {
      const res = await getActivities();
      setActivities(res);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNavigation = (activity: ActivityType) => {
    navigate("/sangati", {
      state: {
        activity, // pass the full activity object
      },
      replace: true,
    });
  };

  useEffect(() => {
    fetchActivity();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="max-w-md mx-auto  h-dvh bg-bg-grey flex flex-col pb-[50px]">
      <div className="pt-3 px-5 md:px-7 ">
        <button className="cursor-pointer" onClick={() => navigate(-1)}>
          <img src="/icons/backbtn.svg" className=" " alt="Back" />
        </button>
      </div>
      <div className="pt-10 flex-1 overflow-y-auto pb-3 px-5 md:px-7">
        <div className="flex flex-col items-end gap-6">
          {activities.map(activity => (
            <div
              role="button"
              onClick={() => handleNavigation(activity)}
              key={activity?.id}
              className={`w-[calc(100%-25px)] bg-white cursor-pointer rounded-[20px] p-2 relative border-2 ${activity?.match_type === "echo"
                  ? "border-[#3B3C36]"
                  : "border-[#00000033]"
                }`}
            >
              {/* match percentage */}
              <div
                className={` flex items-center justify-center absolute -left-[30px] size-[60px] rounded-full border-4 border-sangati-green ${activity?.match_type === "incoming_single_match"
                    ? "bottom-4"
                    : "top-1/2 -translate-y-1/2"
                  }
                  ${activity?.mode_match === "dark_mode"
                    ? "light-bg"
                    : activity?.mode_match === "both_mode"
                      ? "mixed-bg"
                      : "dark-bg"
                  }
                     `}
              >
                <span className="text-white green-stroke-text text-lg font-sharetech">
                  {activity?.compatibility_score &&
                    activity?.match_type !== "echo_match" &&
                    activity?.compatibility_score + "%"}
                </span>
              </div>

              {activity?.match_type === "echo_match" && (
                <div className="mb-1 flex">
                  <div className="bg-[#C83126] rounded-lg px-10 flex items-center gap-2 w-fit">
                    <span className="text-white">
                      <Arrow />
                    </span>
                    <span className="text-white text-16 font-sharetech uppercase">
                      echo
                    </span>
                  </div>
                </div>
              )}
              <div className="ps-[50px]">
                {activity?.match_type === "echo_match" ? (
                  <>
                    <div>
                      {handle?.user.handle === activity?.user?.handle ? (
                        <SelfHandleDisplay name={activity?.user?.handle} />
                      ) : (
                        <OtherHandleDisplay name={activity?.user?.handle} />
                      )}
                    </div>

                    <div className="mt-2">
                      <DateAndArrow
                        color="black"
                        date={moment(activity.created_at).format(
                          "DD MMMM YYYY"
                        )}
                      />
                    </div>

                    <div className="mt-2">
                      {handle?.user.handle === activity?.match_user?.handle ? (
                        <SelfHandleDisplay
                          name={activity?.match_user?.handle}
                        />
                      ) : (
                        <OtherHandleDisplay
                          name={activity?.match_user?.handle}
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <MatchHandleBlock
                    activity={activity}
                    currentUserHandle={handle?.user.handle}
                  />
                )}
              </div>

              {handle?.user.handle === activity?.initiator?.handle &&
                activity?.match_type === "consent_match" && (
                  <div className="absolute top-[-15px] right-[30px] bg-white border-2 border-black h-[30px] w-[50px] flex items-center justify-center">
                    <span className="text-20 font-sharetech text-sangati-green">
                      {activity?.mode_match === "light_mode"
                        ? "001"
                        : activity?.mode_match === "dark_mode"
                          ? "001"
                          : "002"}
                    </span>
                  </div>
                )}
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={() => fetchActivity()}
        className="fixed bottom-3 left-1/2 -translate-x-1/2 z-50"
      >
        <img src="/icons/resend.svg" alt="resend" className="h-[50px] w-auto" />
      </button>
    </div>
  );
};

// Helper components

type HandleDisplayProps = { name?: string };

const OtherHandleDisplay = ({ name }: HandleDisplayProps) => (
  <div className="flex items-center gap-2">
    <div className="size-4 border border-black bg-[#F5C6C6]"></div>
    <div>
      <span className="text-16 text-black">{name}</span>
    </div>
  </div>
);
const SelfHandleDisplay = ({ name }: HandleDisplayProps) => (
  <div className="flex items-center gap-2">
    <div className="size-4 border border-black bg-[#BEEDF3] rounded-full "></div>
    <div>
      <span className="text-16 text-black">{name}</span>
    </div>
  </div>
);

type MatchHandleBlockProps = {
  activity: ActivityType;
  currentUserHandle?: string;
};

const MatchHandleBlock = ({
  activity,
  currentUserHandle,
}: MatchHandleBlockProps) => {
  const initiatorHandle =
    activity?.match_type === "outgoing_single_match"
      ? activity?.match_user?.handle
      : activity?.initiator?.handle;

  const receiverHandle =
    activity?.match_type === "outgoing_single_match"
      ? activity?.user?.handle
      : activity?.initiator?.handle === activity?.match_user?.handle
        ? activity?.user?.handle
        : activity?.match_user?.handle;

  return (
    <>
      {receiverHandle === currentUserHandle ? (
        <SelfHandleDisplay name={receiverHandle} />
      ) : (
        <OtherHandleDisplay name={receiverHandle} />
      )}

      {activity?.match_type === "consent_match" && (
        <div className="mt-2">
          <DateAndArrow
            color="red"
            date={moment(activity.updated_at).format("DD MMMM YYYY")}
          />
        </div>
      )}
      <div className="mt-2 ">
        <DateAndArrow
          color="black"
          date={moment(activity.created_at).format("DD MMMM YYYY")}
        />
      </div>

      <div className="mt-2">
        {initiatorHandle === currentUserHandle ? (
          <SelfHandleDisplay name={initiatorHandle} />
        ) : (
          <OtherHandleDisplay name={initiatorHandle} />
        )}
      </div>
    </>
  );
};

type DateAndArrowProps = { date: string; color: string };
const DateAndArrow = ({ date, color }: DateAndArrowProps) => (
  <div
    className={` flex items-center gap-2
      ${color === "black" ? "text-black" : "text-sangati-orange"}`}
  >
    <Arrow color={color} />
    <span className="text-8">{date}</span>
  </div>
);

type ArrowProps = { color?: string };
const Arrow = ({ color }: ArrowProps) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${color === "black" ? "rotate-180" : ""}`}
  >
    <path d="M15 1L8 5L1 1" stroke="currentColor" strokeLinecap="round" />
    <path d="M15 5L8 9L1 5" stroke="currentColor" strokeLinecap="round" />
    <path d="M15 9L8 13L1 9" stroke="currentColor" strokeLinecap="round" />
  </svg>
);

export default Activity;
